<template>
  <h1 class="text-center">Lists</h1>
</template>

<script>
export default {
  name: "Lists"
}
</script>

<style scoped>

</style>